<template>
  <div class="formula-field" dir="rtl">
    <input
      ref="input"
      type="text"
      class="form-control form-control-sm formula-input"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
    >
    <p v-if="readable && readable !== value" class="formula-readable mb-2">{{ readable }}</p>
    <div v-if="groups.length" class="formula-vars">
      <div v-for="group in groups" :key="group.key" class="var-group">
        <span class="var-step">{{ group.title }}</span>
        <button
          v-for="question in group.questions"
          :key="question.id"
          type="button"
          class="var-chip"
          :title="tokenOf(question)"
          @click="insert(question)"
        >
          {{ chipLabel(question) }}
        </button>
      </div>
    </div>
    <p v-else class="text-muted small mb-0">سؤالی برای استفاده در فرمول نیست.</p>
  </div>
</template>

<script>
import {
  FORMULA_QUESTION_TYPES,
  formulaToken,
  groupQuestionsByStep,
  humanizeFormula,
  questionVariable,
  questionTitle,
  visibleFormItems
} from "../formQuestionContext";

export default {
  name: "FormFormulaField",
  props: {
    value: {
      type: String,
      default: ''
    },
    questions: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'مثلا 500000 + {{q:12}} * 10000'
    }
  },
  computed: {
    eligibleQuestions() {
      return visibleFormItems(this.questions).filter(item => (
        item.type !== 'step' && FORMULA_QUESTION_TYPES.indexOf(item.type) !== -1
      ))
    },
    groups() {
      return groupQuestionsByStep(this.questions, this.eligibleQuestions)
    },
    readable() {
      return humanizeFormula(this.value, this.questions)
    }
  },
  methods: {
    tokenOf(question) {
      return formulaToken(question)
    },
    chipLabel(question) {
      return questionVariable(question) || questionTitle(question)
    },
    insert(question) {
      const token = formulaToken(question)
      const input = this.$refs.input
      const current = this.value || ''
      if (!input) {
        this.$emit('input', current + token)
        return
      }
      const start = input.selectionStart || current.length
      const end = input.selectionEnd || current.length
      const next = current.slice(0, start) + token + current.slice(end)
      this.$emit('input', next)
      this.$nextTick(() => {
        const cursor = start + token.length
        input.focus()
        input.setSelectionRange(cursor, cursor)
      })
    }
  }
}
</script>

<style scoped>
.formula-input {
  font-family: Tahoma, sans-serif;
  direction: ltr;
  text-align: left;
  margin-bottom: 6px;
}

.formula-readable {
  font-size: 12px;
  color: #6f42c1;
  background: #f6f3fb;
  border-radius: 8px;
  padding: 6px 8px;
}

.formula-vars {
  display: grid;
  gap: 8px;
}

.var-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.var-step {
  font-size: 11px;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 2px 8px;
}

.var-chip {
  border: 1px solid #e4d7fb;
  background: #f8f5ff;
  color: #6f42c1;
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 12px;
  cursor: pointer;
}

.var-chip:hover {
  border-color: #6f42c1;
}
</style>
